/**
 * AJ-03 (formation du 28/10) — les patients qui attendent la chargée de
 * clientèle au comptoir : fiche à confirmer, ou écart d'offre à trancher.
 * Au-delà du seuil, l'accueil du centre est prévenu une fois : « appelez la
 * chargée ».
 */
/** Le seuil d'alerte par défaut, en minutes : réglable dans Configuration. */
export const SEUIL_ATTENTE_CHARGEE_MINUTES = 5;
/** Ce que le patient attend de la chargée : les deux peuvent se cumuler. */
export const MOTIFS_ATTENTE_CHARGEE = ['FICHE_A_CONFIRMER', 'ECART_OFFRE', 'VERIFICATION'];
export const LIBELLE_MOTIF_ATTENTE_CHARGEE = {
    FICHE_A_CONFIRMER: 'fiche à confirmer',
    ECART_OFFRE: 'écart d’offre',
    // Décision 372 — une personne non éligible qui se dit couverte.
    VERIFICATION: 'vérification',
};
/** L'attente a-t-elle atteint le seuil ? À la minute près, comme l'affichage « depuis 5 min ». */
export function attenteDepasseLeSeuil(depuis, maintenant, seuilMinutes) {
    return maintenant.getTime() - depuis.getTime() >= seuilMinutes * 60_000;
}
/**
 * Décision 342 — ce que l'accueil lit sur la ligne d'une fiche envoyée à
 * confirmer : la chargée n'a pas encore répondu, ou elle a répondu et le
 * patient peut entrer (confirmée, couverte), ou ne le peut pas (infirmée, ou
 * confirmée mais pas couverte : le motif le dit).
 */
export const REPONSES_CHARGEE = ['EN_ATTENTE', 'PEUT_ENTRER', 'NE_PEUT_PAS_ENTRER'];
export const LIBELLE_REPONSE_CHARGEE = {
    EN_ATTENTE: 'En attente',
    PEUT_ENTRER: 'Peut entrer',
    NE_PEUT_PAS_ENTRER: 'Ne peut pas entrer',
};
/**
 * La réponse d'une ligne. Tant qu'il attend encore quelque chose de la
 * chargée (fiche ou écart d'offre), il attend. Ensuite, c'est le verdict
 * d'éligibilité du moment qui dit s'il entre : une seule règle, celle de la
 * fiche.
 */
export function reponseDeLaChargee(ligne) {
    if (ligne.motifs.length > 0)
        return { reponse: 'EN_ATTENTE', motifRefus: null };
    if (ligne.verification?.statut === 'ACCEPTEE')
        return { reponse: 'PEUT_ENTRER', motifRefus: null };
    if (ligne.verification?.statut === 'REFUSEE') {
        return { reponse: 'NE_PEUT_PAS_ENTRER', motifRefus: ligne.verification.motifRefus };
    }
    if (ligne.etatConfirmation === 'CONFIRME' && ligne.eligibilite?.eligible === true) {
        return { reponse: 'PEUT_ENTRER', motifRefus: null };
    }
    return { reponse: 'NE_PEUT_PAS_ENTRER', motifRefus: ligne.eligibilite?.message ?? null };
}
/**
 * Décision 342 — LA règle du chiffre rouge de l'accueil (choix de
 * l'orchestrateur, ajustable par le TL ici seulement) : une réponse de la
 * chargée que l'accueil n'a pas encore ouverte. Une attente sans réponse ne
 * compte pas : elle ne demande rien à l'accueil.
 */
export function reponseNonVue(ligne) {
    if (ligne.reponse === 'EN_ATTENTE' || ligne.reponduLe === null)
        return false;
    return ligne.vueLe === null || Date.parse(ligne.vueLe) < Date.parse(ligne.reponduLe);
}
/** Le chiffre rouge du menu : le nombre de lignes où `reponseNonVue`. */
export function compterReponsesNonVues(lignes) {
    return lignes.filter(reponseNonVue).length;
}
//# sourceMappingURL=attente-chargee.js.map